import { Controller } from "@hotwired/stimulus"

// Line items and browser-only draft storage for the public invoice and quote generators.
// The preview itself is the real PDF (see pdf_preview_controller.js).
export default class extends Controller {
  static targets = ["lines", "template", "taxRate"]
  static values = { storageKey: String, restore: Boolean }

  connect() {
    if (this.restoreValue) this.restore()
    this.syncTaxPlaceholders()
  }

  save() {
    this.syncTaxPlaceholders()
    try {
      localStorage.setItem(this.storageKeyValue, JSON.stringify(this.fields().map((field) => [field.name, field.value])))
    } catch {}
  }

  addLine() {
    this.appendLine()
    this.linesTarget.lastElementChild?.querySelector("input")?.focus()
    this.changed()
  }

  removeLine(event) {
    event.currentTarget.closest("[data-line]").remove()
    if (!this.linesTarget.querySelector("[data-line]")) this.appendLine()
    this.changed()
  }

  clear() {
    try { localStorage.removeItem(this.storageKeyValue) } catch {}
    this.element.querySelectorAll("input:not([type=hidden]), textarea").forEach((field) => {
      if (/\[(issue_date|sender_country_code)\]/.test(field.name)) return
      field.value = field.type === "number" && !field.closest("[data-line]") ? "0" : ""
    })
    this.linesTarget.querySelectorAll("[data-line]").forEach((line, index) => { if (index > 0) line.remove() })
    this.changed()
  }

  changed() {
    this.save()
    this.dispatch("changed")
  }

  appendLine() {
    this.linesTarget.append(this.templateTarget.content.cloneNode(true))
    this.syncTaxPlaceholders()
  }

  // Empty line tax fields use the document rate, as in the app's editor.
  syncTaxPlaceholders() {
    const rate = this.hasTaxRateTarget ? this.taxRateTarget.value || "0" : "0"
    this.linesTarget.querySelectorAll("[data-line-field=tax_rate_override]").forEach((field) => { field.placeholder = rate })
  }

  fields() {
    return [...this.element.querySelectorAll("input:not([type=hidden]):not([type=file]), textarea, select")]
  }

  restore() {
    let fields
    try { fields = JSON.parse(localStorage.getItem(this.storageKeyValue) || "null") } catch { return }
    if (!Array.isArray(fields)) return

    const lineCount = fields.filter(([name]) => name === "document[line_items][][description]").length
    while (this.linesTarget.querySelectorAll("[data-line]").length < lineCount) this.appendLine()

    const counters = {}
    fields.forEach(([name, value]) => {
      const candidates = this.element.querySelectorAll(`[name="${CSS.escape(name)}"]`)
      const index = counters[name] = (counters[name] ?? -1) + 1
      const field = candidates[name.includes("[]") ? index : 0]
      if (field && field.type !== "hidden" && field.type !== "file") field.value = value
    })
  }
}
